import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import ButtonWrapper from '@/shared/ui/buttonWrapper'
import { AppButton } from '@/shared/ui/button'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { StarterPackItem } from '../starterPackPage/ui/starterPackItem'

export const StarterPackClaimPage = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const btnTexts = lang[userLang].pages.btnTexts
  const texts = lang[userLang].pages.starterPackClaim

  useHideNav()

  return (
    <div className={classes.root}>
      <span className={classes.heading}>{texts.heading}</span>
      <span className={classes.subHeading}>{texts.subHeading}</span>
      <div className={classes.starterPackList}>
        <StarterPackItem />
        <StarterPackItem />
        <StarterPackItem />
        <StarterPackItem />
      </div>
      <ButtonWrapper style={{ left: '0' }}>
        <AppButton className={classes.button}>{btnTexts.time}</AppButton>
      </ButtonWrapper>
    </div>
  )
}
